module.exports = __webpack_public_path__ + "static/nia-evans-772336703ed8d47c534808ffb438291a.jpg";